module.exports = __webpack_public_path__ + "img/0603-l.f618e64a.svg";